import { and } from '@lumapps/utils/function/predicate/and';
import type { HTMLElementConvertOption } from '@lumapps/wrex/serialization/html/fromHTML/types';
import { matchAttribute, matchNode } from '@lumapps/wrex/serialization/html/fromHTML/utils';

import { CLASSNAME } from '../../../components/blocks/EmbeddedVideo';
import { EMBEDDED_VIDEO } from '../../../constants';
import { createEmbeddedVideo } from '../../../utils/createEmbeddedVideo';

type ElementTypes = typeof EMBEDDED_VIDEO;

/**
 * Element convert options.
 *
 * Warning: the order of these options does matter!
 */
export const ELEMENTS: { [Element in ElementTypes]: HTMLElementConvertOption<Element> } = {
    [EMBEDDED_VIDEO]: {
        type: EMBEDDED_VIDEO,
        test: and(
            matchNode({ tagName: 'iframe' }),
            matchAttribute('src', /./),
            matchAttribute('className', new RegExp(CLASSNAME)),
        ),
        transform: ({ properties }: any) => {
            return createEmbeddedVideo({ url: properties.src, title: properties.title });
        },
    },
};
